module.exports = __webpack_public_path__ + "img/pro4.8cad0872.png";